import { EmptystateSearchNoResultsColored } from "components/icons/generated";
import EmptyState from "ds/components/EmptyState";

type CommandPaletteEmptyStateProps = {
  message?: string;
};

const CommandPaletteEmptyState = ({
  message = "No results found",
}: CommandPaletteEmptyStateProps) => {
  return (
    <EmptyState
      title={message}
      caption="Check the spelling or try something less specific."
      icon={EmptystateSearchNoResultsColored}
    />
  );
};

export default CommandPaletteEmptyState;
